import React from 'react';
import { FaBolt, FaProjectDiagram, FaPen, FaEnvelope } from 'react-icons/fa';
import '../styles/Dashboard.css';

const Dashboard = () => {
  const stats = [
    { label: 'Total Services', value: '8', icon: FaBolt, color: '#ffd700' },
    { label: 'Projects', value: '6', icon: FaProjectDiagram, color: '#25D366' },
    { label: 'Blog Posts', value: '12', icon: FaPen, color: '#1877F2' },
    { label: 'Subscribers', value: '45', icon: FaEnvelope, color: '#e74c3c' }
  ];

  return (
    <div className="dashboard-page">
      <h1>Dashboard</h1>
      <p>Welcome back, Admin! Here's your overview.</p>
      <div className="stats-grid">
        {stats.map((stat, i) => (
          <div className="stat-card" key={i}>
            <div className="stat-icon" style={{ background: stat.color }}><stat.icon /></div>
            <div className="stat-info"><h3>{stat.value}</h3><p>{stat.label}</p></div>
          </div>
        ))}
      </div>
      <div className="recent-section">
        <h2>Recent Activity</h2>
        <div className="activity-list">
          <div className="activity-item">📝 New blog post published - April 15, 2026</div>
          <div className="activity-item">📧 New contact form submission - April 14, 2026</div>
          <div className="activity-item">📬 New newsletter subscriber - April 13, 2026</div>
          <div className="activity-item">🏗️ Project updated - April 12, 2026</div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
